<template>
  <loader
    v-if="isLoader"
    :class="$style.loader"
  />
  <div
    v-else
    :class="[$style.card]"
  >
    <div :class="$style.buttonContainer">
      <button
        :class="$style.buttonBig"
        @click="openModal('watermarkModal')"
      >
        {{ $t('watermarkModal.header') }}
      </button>
    </div>
    <label
      v-for="([key, value], index) in Object.entries(result)"
      :key="index + key"
      :class="$style.settContainer"
      @click="check(key)"
      @click.stop.prevent
    >
      <div :class="$style.label">
        {{ $t(`settings.baseSettings.${value.key}`) }}
      </div>
      <toggle-button
        v-model="value.value"
        :value="value.value"
        :sync="true"
        @click.native.prevent
      />
    </label>
    <watermark-modal
      id="watermarkModal"
      :class="$style.modal"
      :data="watermarkSettings"
      @update="updateWatermark"
      @close="closeModal('watermarkModal')"
    />
  </div>
</template>

<script>
  import { ToggleButton } from 'vue-js-toggle-button';
  import Vue from 'vue';
  import { getCommonSettings, getWatermarkSettings } from '@/api/methods/settings';
  import Loader from '@/components/common/blocks/loader.vue';
  import WatermarkModal from '@/views/settings/general/watermarkModal.vue';

  Vue.component('ToggleButton', ToggleButton);

  export default {
    components: { WatermarkModal, Loader },
    data: () => ({
      result: {},
      watermarkSettings: {},
      isLoader: false,
    }),
    computed: {
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
      currentType() {
        return this.selectedComputer.type === 'folder' ? 2 : 0;
      },
    },
    created() {
      this.getSettings();
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/cancel') {
            await this.getSettings();
          }
        },
      });
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/paramChanged') {
            await this.getSettings();
          }
        },
      });
    },
    methods: {
      closeModal(id) {
        const el = document.getElementById(id);
        if (el) {
          el.style.display = 'none';
        }
      },
      openModal(id) {
        const el = document.getElementById(id);
        if (el) {
          el.style.display = 'flex';
        }
      },
      check(key) {
        this.$set(this.result[key], 'value', !this.result[key].value);
        this.$store.commit('settings/addCommonSettings', {
          key,
          value: this.result[key],
        });
      },
      updateWatermark(key, value) {
        this.$set(this.watermarkSettings, key, value);
        this.$store.commit('settings/addWatermarksSettings', {
          key,
          value,
        });
      },
      async getSettings() {
        try {
          this.isLoader = true;
          if (this.selectedComputer.id) {
            this.promise = await getCommonSettings(this.selectedComputer.id, this.currentType).then(({ data }) => {
              if (data) {
                this.result = data.result;
              }
            });
            const { data } = await getWatermarkSettings(this.selectedComputer.id, this.currentType);
            this.watermarkSettings = data.result;

            const settings = this.$store.getters['settings/commonSettings'];
            if (settings) {
              Object.entries(settings).forEach(([key, value]) => {
                this.result[key].value = value.value;
              });
            }
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoader = false;
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .settContainer {
    display: flex;
    padding: 10px 0px;
    margin: 0px 10px;
    justify-content: space-between;
    // width: 90%;
    align-items: center;
    cursor: pointer;
    // margin-left: 10px;
    &:hover {
      background: $light-gray;
    }
  }

  .label {
    margin: 0px 10px;
    font-size: 14px;
  }

  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
    > :not(:first-child):not(:last-child) {
      border-bottom: 0.2px solid #eee;
    }
  }

  .buttonContainer {
    margin: 10px 10px 15px 10px;
  }

  .buttonBig {
    height: 45px;
    width: 215px;
    background: #2985bf;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .buttonBig:hover {
    background: #3a96d0;
  }

  .disabled,
  .disabled * {
    cursor: default;
  }

  .modal {
    display: none;
    z-index: 3000;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 1220px;
  }
</style>
